module.exports = __webpack_public_path__ + "media/images/img_service_risk-ea0c6da0042b3f9531d82a319c751e62.png";